import {useEffect, useState} from "react";
import {FormProvider, SubmitHandler, useForm} from "react-hook-form";
import {useNavigate, useParams} from "react-router-dom";
import SubTitle from "../../components/SubTitle";
import {useCreateMutation, useGetItemQuery} from "../../hooks/useQueryHooks";
import {ResponseItem} from "../../models/clientModels/interfaces/Response";

import * as Params from "../../models/clientModels/interfaces/apiParams";

import {useMediaQuery} from "@mui/material";
import {useQueryClient} from "react-query";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {tokenSelector, userState} from "../../Recoil/Atom/authState";
import {snackBarState, snackBarToggleState} from "../../Recoil/Atom/snackBarState";
import * as specificationApi from "../../api/equipmentApi/specificationApi";
import * as workOrderApi from "../../api/workOrderApi/workOrderApi";
import ConfirmButtonGroup from "../../components/ConfirmButtonGroup";
import MWProgress from "../../components/MWProgress";
import {EQSpecification} from "../../models/serverModels/equipment/EQSpecification";
import {EQWorkOrder, initializeWorkOrder} from "../../models/serverModels/workOrder/EQWorkOrder";
import {FormSection} from "../../styledComponents/StyledCreateForm";
import WorkOrderForm from "./WorkOrderForm";
import WorkOrderFormMobile from "./WorkOrderFormMobile";
import {workOrderSchema} from "../../validation/workOrderSchema";
import {yupResolver} from "@hookform/resolvers/yup";

const CreateWorkOrder = () => {
  const {id} = useParams();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const tokenState = useRecoilValue(tokenSelector);
  const userData = useRecoilValue(userState);
  console.log("⚾ ~ CreateWorkOrder ~ userData:", userData);

  const setSnackBarState = useSetRecoilState(snackBarState);
  const setSnackBarToggle = useSetRecoilState(snackBarToggleState);

  const isMobile = useMediaQuery("(min-width: 960px)");

  const [workOrder, setWorkOrder] = useState<EQWorkOrder>(initializeWorkOrder);

  const {data, isLoading: isGetLoading} = useGetItemQuery<ResponseItem<EQSpecification>>({
    key: ["Equipment", {id, token: tokenState}],
    api: () => specificationApi.getItem({id: parseInt(id!), token: tokenState}),
    options: {
      onSuccess: (data: ResponseItem<EQSpecification>) => {
        setWorkOrder({
          ...workOrder,
          specificationUID: parseInt(id!),
          specification: data?.item!,
          writerUID: userData.uid,
          writerName: userData.name || "작성자 없음",
          writerDepartmentUID: userData?.departmentUID,
          department: userData?.department?.name || "작성부서 없음",
        });
      },
    },
  });
  console.log("⚾ ~ CreateWorkOrder ~ workOrder:", workOrder);

  console.log("⚾ ~ CreateWorkOrder ~ data:", data);
  const {mutate: createMutate, isLoading: isUpdateLoading} = useCreateMutation<
    ResponseItem<EQWorkOrder>,
    Params.Create<EQWorkOrder>
  >({
    api: workOrderApi.create,
    options: {
      onSuccess: () => {
        setSnackBarToggle(true);
        setSnackBarState("update");
        navigate("/WorkOrder");
        queryClient.invalidateQueries("WorkOrderList");
        queryClient.invalidateQueries("RequestedList");
      },
    },
  });

  const methods = useForm<EQWorkOrder>({
    defaultValues: workOrder,
    resolver: yupResolver(workOrderSchema),
  });

  const {reset} = methods;

  useEffect(() => {
    reset(workOrder);
  }, [data?.item, workOrder]);

  const onSubmit: SubmitHandler<EQWorkOrder> = (data) => {
    createMutate({
      token: tokenState,
      isManual: false,
      item: {...workOrder, ...data},
    });
  };
  return (
    <FormProvider {...methods}>
      <SubTitle subTitle="기기 점검/정비 의뢰서 작성" />
      {isUpdateLoading && <MWProgress />}
      {isGetLoading ? (
        <MWProgress />
      ) : (
        <FormSection>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            {isMobile ? <WorkOrderForm /> : <WorkOrderFormMobile />}
            <ConfirmButtonGroup link="/workOrder" cancelText="취소" confirmText="요청" />
          </form>
        </FormSection>
      )}
    </FormProvider>
  );
};

export default CreateWorkOrder;
